var React = require('react');

function PhoneFilled (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#ffdb00","d":"M13.68 0H2.32A1.965 1.965 0 00.355 1.967v23.068C.355 26.12 1.233 27 2.32 27h11.36c1.085 0 1.965-.88 1.965-1.965V1.967C15.645.882 14.765 0 13.68 0zM8 25.059a1.254 1.254 0 110-2.509 1.254 1.254 0 010 2.509zm6.173-4.299H1.828V3.32h12.345V20.76z"}));
}

PhoneFilled.defaultProps = {"fill":"none","viewBox":"0 0 16 27"};

module.exports = PhoneFilled;

PhoneFilled.default = PhoneFilled;
